<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <h1
        class="md:hidden bg-stone-white text-[30px] font-semibold py-2 px-4"
      >
        {{ adviceDetail.title }}
      </h1>
      <HelpHeroCard
        :heroCardData="adviceDetail"
        className="flex"
        :showDescriptionBox="!isMobile"
        :fullBanner="false"
        :showIntro="false"
      ></HelpHeroCard>
      <div class="bg-stone-white">
        <NuxtLayout name="center">
          <div class="md:py-16 lg:py-24 py-12">
            <div class="md:grid md:grid-cols-2 md:gap-20">
              <div class="condition-content">
                <div class="text-lg-30 font-semibold mb-4">
                  {{ adviceDetail.intro_text }}
                </div>
                <div v-html="adviceDetail.body_text"></div>
              </div>
              <div
                class="flex flex-col justify-start space-y-4"
                v-if="adviceDetail.list_type == 'tests' ? adviceDetail.tests.length > 0 : adviceDetail.conditions.length > 0"
 
              >
                <div class="flex space-x-6 p-4">
                  <div class="w-10 h-10 shrink-0">
                    <NuxtImg
                      loading="lazy"
                      src="/icons/book-open-full.svg"
                      alt="BookOpenIcon"
                      class="w-full"
                      width="62"
                      height="57"
                    />
                  </div>
                  <div class="flex flex-col justify-center">
                    <h3>{{ adviceDetail.conditions_title }}</h3>
                  </div>
                </div>
                <div class="flex flex-col">
                  <HelpList
                    :categorySlug="adviceDetail.slug"
                    :listData="item"
                    :listType="adviceDetail.list_type"
                    v-for="(item, index) in (adviceDetail.list_type == 'tests' ? adviceDetail.tests : adviceDetail.conditions)"
                    :key="index"
                  ></HelpList>
                </div>
              </div>
            </div>
          </div>
        </NuxtLayout>
      </div>

      <NuxtLayout name="center">
        <div class="pt-12 pb-4 md:py-12 lg:py-16 justify-center">
          <CommonUSPBlock :itemList="uspitems.data"></CommonUSPBlock>
        </div>
      </NuxtLayout>

      <div class="bg-secondary-lighter" v-if="products.length > 0">
        <NuxtLayout name="center" class="pt-12 md:pt-20 pb-12">
          <CommonMostPopularTests
            :products="products"
            title=""
            view-detail-button-title=""
            view-all-button-title=""
          >
          </CommonMostPopularTests>
        </NuxtLayout>
      </div>

      <NuxtLayout name="center">
        <CommonLiveChatBlock></CommonLiveChatBlock>
      </NuxtLayout>

      <CommonLatestBlogs
        v-if="globalStore.siteSettings.display_blog == true"
        category="3522"
        :title="
          $t('blog.latestSexualHealthBlog', { name: '' })
        "
        :button-title="$t('homePage.visitMorePosts')"
      >
      </CommonLatestBlogs>

      <ClinicCTABlock
        imgSrc="USPs_graphic_03_1"
        :getStarted="true"
      ></ClinicCTABlock>
    </div>
  </div>
</template>

<script setup>
import { TransitionRoot } from "@headlessui/vue";
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();

const products = ref();
const route = useRoute();
const isMobile = useScreenSize("sm");
const adviceDetail = ref({});
const slug = route.fullPath.split("/").pop();
const {
  data: resultData,
  pending,
  error: errorMessage,
  refresh,
} = await useHelpAdviceDetailSlug(slug);
adviceDetail.value = resultData.value.data;

const { data: reviewResult, refreshBlockReview } = await useBlockReview(1);
products.value = adviceDetail.value.most_popular_tests;

const { data: uspitems, refreshUSPItems } = await useUSPItems(1);

useMetaTitles(adviceDetail.value, "help-and-advice-subcategory");

const breadcrumbs = getBreadcrumbs(
  "help-and-advice-subcategory",
  adviceDetail.value
);
</script>
<style scoped>
div.sub-category:nth-child(6) {
  border-top-width: 2px;
}

div.sub-category:nth-child(11) {
  border-top-width: 2px;
}
</style>
